import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M10.91 11.5c.342.155.714.234 1.09.23.382 0 .76-.078 1.11-.23l4.2-1.82a.752.752 0 1 0-.6-1.38l-4.2 1.82a1.24 1.24 0 0 1-1 0l-4.2-1.83a.75.75 0 0 0-1.011.96.76.76 0 0 0 .401.42z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M5 20.25h14a2.75 2.75 0 0 0 2.75-2.75v-11A2.75 2.75 0 0 0 19 3.75H5A2.75 2.75 0 0 0 2.25 6.5v11A2.75 2.75 0 0 0 5 20.25M4.116 5.616A1.25 1.25 0 0 1 5 5.25h14a1.25 1.25 0 0 1 1.25 1.25v11A1.25 1.25 0 0 1 19 18.75H5a1.25 1.25 0 0 1-1.25-1.25v-11c0-.332.132-.65.366-.884",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }